import React, { useEffect } from "react";
import { navigate } from "@reach/router"

import "./FormPage.scss";

import TextImageBlock from "../TextImageBlock/TextImageBlock";

import Book_A_Valuation from "../forms/book_a_valuation";
import Book_A_Viewing from "../forms/book-a-viewing";
import Branch_Contact from "../forms/branch-contact-form";
import Staff_Contact from "../forms/member-form";
import Contact_Form from "../forms/contact-form";
import Ask_Question_Form from "../forms/ask-question-form";
import SendToFriend_Form from "../forms/send-property-to-friend";
import Instant_valuation_Form from "../forms/instant-valuation-form";
import PaymentForm from "../forms/payment";
import CollectionForm from "../forms/collection-form";
import Rent_Home from "../forms/rent_a_home";
import Complaints_Form from "../forms/complaints-form";
import Bulk_Enquiry_Form from "../forms/bulk-enquiry-form";
import Referral_Form from "../forms/referral_form";

import ContentModule from "../../modules/content_module";
import { capitalize } from "lodash";

import {leadooPageSlot, defaultArea_Slug} from "../../common/constant";
import {PageLinks} from "../../common/page-links";


const FormsWrapper = ({ form_data, form_type, location, to_email_id, branch_name, staff_name, menu_slug, description, title, GQLModules }) => {

    let prev_state = location?.state

    //console.log("prev_state ==>", prev_state, form_type);

    let pathname = menu_slug ? menu_slug.replace(/-/g, '_') : "";

    useEffect(() => {
        if(form_type === "book_a_viewing" && prev_state === null){
            navigate(`/${PageLinks.property_for_sale}/${defaultArea_Slug}/`)
        }
    }, [form_type])

    //console.log("form_type", form_type);


    return (
        <React.Fragment>
            <div className={`form-wrapper ${form_type === "payment" ? "payment_form" : ""}`}>
                <h1 className="form_heading">{form_data?.title ? form_data?.title : "Contact Us"}</h1>

                {prev_state?.form_type === "book_a_viewing" || prev_state?.form_type === "send_to_friend" ?
                    <p><span>{capitalize(prev_state?.property_data?.title)}</span><br />{prev_state?.property_data?.display_address}</p>
                    :
                    <p>{form_data?.content ? form_data?.content : ""}</p>
                }
                
                {description && <ContentModule Content={description} />}

                {prev_state?.form_type === "book_a_viewing" ?
                    <Book_A_Viewing propertyData={prev_state?.property_data} property_url={prev_state?.property_url} to_email_id={prev_state?.to_email_id} />
                : form_type === "book_a_valuation" ?
                    <Book_A_Valuation />
                : form_type === "branch_contact" ?
                    <Branch_Contact to_email_id={to_email_id} formLabel={branch_name} branch_name={branch_name} />

                : form_type === "instant_valuation" ?
                    <Instant_valuation_Form to_email_id={to_email_id} formLabel={branch_name} branch_name={branch_name} />

                : form_type === "staff_contact" ?
                    <Staff_Contact to_email_id={to_email_id} formLabel={staff_name} staff_name={staff_name} />
                : (form_type === "send_to_friend") ?
                    <SendToFriend_Form propertyData={prev_state?.property_data} property_url={prev_state?.property_url} />
                : form_type === "ask_a_question" ?
                    <Ask_Question_Form to_email_id={to_email_id}/>
                : form_type === "payment" ?
                    <PaymentForm  to_email_id={to_email_id}/>
                : form_type === "join_collection" ?
                    <CollectionForm  to_email_id={to_email_id}/>
                : form_type === "complaints" ?
                    <Complaints_Form  to_email_id={to_email_id}/>
                : form_type === "rent_a_home" ?
                    <Rent_Home to_email_id={to_email_id}/>
                : form_type === "bulk_enquiry" ?
                    <Bulk_Enquiry_Form to_email_id={to_email_id} prev_state={prev_state}/>
                : form_type === "referral_forms" ?
                    <Referral_Form to_email_id={to_email_id}  title={title} />
                : form_type === "none" ?
                    ""
                :
                    <Contact_Form  to_email_id={to_email_id} title={title} />
                }

                {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
                    return(<>
                        {Module.__typename === "GLSTRAPI_ComponentComponentsTextBlockWithImage" &&  <TextImageBlock key={Module} Module={Module}/>}
                    </>
                    )
                })
                }
            </div>

            {/* {leadooPageSlot?.sell_property &&
                <ld-slot name={leadooPageSlot[pathname]}></ld-slot>
            } */}
        </React.Fragment>
    );
};
export default FormsWrapper;
